import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AllAppsRaw = React.lazy(() => import(/* webpackChunkName: "AdminAAPayroll" */ 'containers/Admin/AAPayroll/AAPayroll'));
export const AdminAAPayroll = () => (React.createElement(Page, { title: "AA Payroll", description: "AA Payroll" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AllAppsRaw, null)))));
